import * as React from 'react';
import styled from 'styled-components';
import { IBadgeProps } from './badge-types';
import { Typography } from '../typography';
import { selectThemeSemantics } from '../../styling';

const BadgeBase = React.memo((props: IBadgeProps) => {
    const { label, className, hidden, title } = props;

    return hidden ? null : (
        <Typography.H6 className={className} title={title}>
            {label}
        </Typography.H6>
    );
});

BadgeBase.displayName = 'Badge';

export const Badge = styled(BadgeBase).attrs({
    className: String('ap-badge')
})`
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    padding: ${selectThemeSemantics(s => `${s.gap.s} ${s.gap.l}`)};
    background-color: ${({ theme: { badge: { colors } } }) => colors.backgroundColor};
    border-radius: ${({ theme: { badge: { composites } } }) => composites.borderRadius};
    color: ${({ theme: { badge: { colors } } }) => colors.foregroundColor};
    max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : '100%')};
`;
